import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import { Badge, IconButton, Typography } from '@mui/material';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useCommunicationCount } from '../hooks/useCommunicationCount';
import CommunicationModal from './CommunicationModal';
import { badgeStyle } from '../styles/styles';

const CommunicationIconComponent: React.FC = () => {
  const { t } = useTranslation();
  const { count,  anchorEl, handleClick, handleClose, isModalOpen } = useCommunicationCount();

  return (
    <>
      <IconButton
        sx={{ display: 'flex', justifyContent: 'start', gap: 2, '&:hover': {backgroundColor: 'transparent'} }}
        color="inherit"
        onClick={handleClick}
        aria-label={t('communication.iconAria', 'communications')}
      >
        <Badge badgeContent={count} color="error" sx={badgeStyle}>
          <MessageOutlinedIcon />
        </Badge>
        <Typography
          sx={{
            display: {
              xs: 'block',
              md: 'none',
            },
          }}
        >
          {t('communication.label', 'Communications')}
        </Typography>
      </IconButton>
      {isModalOpen && (
        <CommunicationModal
          open={isModalOpen}
          onClose={handleClose}
          anchorEl={anchorEl as HTMLButtonElement}
        />
      )}
    </>
  );
};

export default CommunicationIconComponent;
